import React from "react";

import modifyMarkup from "../../utils/modifyMarkup";
import * as styles from "./ArticleContent.module.css";

const ArticleContent = ({ content }) => {
  return (
    <div
      dangerouslySetInnerHTML={{
        __html: modifyMarkup(content),
      }}
      className={styles.articleContent}
    />
  );
};

export default ArticleContent;
